import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'
import { 
  Form, FormGroup, ControlLabel, FormControl, Checkbox, Panel, Row, Col 
} from 'react-bootstrap'
import DocumentTitle from "react-document-title"

import isObjectEqual from '../../lib/isObjectEqual.js'
import MarkdownField from '../lib/MarkdownField.jsx'
import { getActivitiesPerSupplier } from '../selectors' 
import { getText } from '../lib/text.js'

const shortField = {
  marginRight: 20,
  width: 100
}

const longField = {
  marginRight: 20,
  width: 245
}

/** Activity Editor 
 * stateless, pure
 */
type Props = {
  supplier: Object,
  onChange: (string, any) => void,
}

class SupplierEditor extends React.PureComponent 
{
  constructor(props) {
    super(props)
    this.state = { modal: null, open: false }
  }
  

  props: Props

  
  render() {
    const props = this.props
    const s = props.supplier

    return (
      <div>
        <DocumentTitle title= {`${getText("Proveedor")}: ${props.supplier.name}`} />
        <Panel>
          <Panel.Body>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{getText("Nombre proveedor")}: </ControlLabel>
                  <FormControl 
                    type="text" 
                    value={props.supplier.name}
                    onChange={evt => props.onChange({name: evt.target.value})} 
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>{getText("Nombre contacto")}: </ControlLabel>
                  <FormControl 
                    type="text" 
                    value={props.supplier.contactPerson}
                    onChange={evt => props.onChange({contactPerson: evt.target.value})}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{getText("Teléfono")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={props.supplier.phoneNumber}
                    onChange={evt => props.onChange({phoneNumber: evt.target.value})}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>{getText("Correo electrónico")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={props.supplier.email}
                    onChange={evt => props.onChange({email: evt.target.value})}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Panel.Body>
        </Panel>

        <Panel>
          <Panel.Body>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{getText("Razón social")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={props.supplier.socialReason}
                    onChange={evt => props.onChange({socialReason: evt.target.value})}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>{getText("Número de cuenta")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={props.supplier.accountNumber}
                    onChange={evt => props.onChange({accountNumber: evt.target.value})}
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <ControlLabel>{getText("CIF")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={props.supplier.cif}
                    onChange={evt => props.onChange({cif: evt.target.value})}
                  />
                </FormGroup>
                <FormGroup>
                  <ControlLabel>{getText("Descripción banco")}:</ControlLabel>
                  <FormControl
                    type="text"
                    value={props.supplier.bankDescription}
                    onChange={evt => props.onChange({bankDescription: evt.target.value})}
                  />
                </FormGroup>
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
        
        <MarkdownField
          onChange={x => props.onChange({notes: x})}
          value={s.notes}
          label={getText("Notas")}
        />
          
        <Panel>
          <Panel.Heading>Información para reservas</Panel.Heading>
          <Panel.Body>
            <MarkdownField
              onChange={x => props.onChange({reservationsNotes: x})}
              value={s.reservationsNotes}
              label={getText("Instrucciones")}
            />
            <Form inline>
              <div>
                <Checkbox
                  style={shortField}
                  checked={s.enableReservationsPhone}
                  onChange={evt => props.onChange({enableReservationsPhone: evt.target.checked})}              
                >
                  Llamar
                </Checkbox>
                {
                  s.enableReservationsPhone && (
                    <span>
                      <FormGroup style={longField}>
                        <ControlLabel style={{minWidth: 70}}>Teléfono</ControlLabel>
                        <FormControl 
                          type="text" 
                          value={s.useReservationsPhone ? (s.reservationsPhone || "") : s.phoneNumber}
                          onChange={evt => props.onChange({reservationsPhone: evt.target.value})}
                          disabled={!s.useReservationsPhone}
                        />
                      </FormGroup>
                      <Checkbox
                        style={longField}
                        checked={s.useReservationsPhone}
                        onChange={evt => props.onChange({useReservationsPhone: evt.target.checked})}              
                      >
                        Usar otro teléfono para reservas
                      </Checkbox>
                    </span>
                  )
                }
              </div>
              <div>
                <Checkbox
                  style={shortField}              
                  checked={s.enableReservationsEmail}
                  onChange={evt => props.onChange({enableReservationsEmail: evt.target.checked})}              
                >
                  Enviar email
                </Checkbox>
                {
                  s.enableReservationsEmail && (
                    <span>
                      <FormGroup style={longField}>
                        <ControlLabel style={{minWidth: 70}}>Email</ControlLabel>
                        <FormControl 
                          disabled={!s.useReservationsEmail}
                          type="text" 
                          value={s.useReservationsEmail ? (s.reservationsEmail || "") : s.email}
                          onChange={evt => props.onChange({reservationsEmail: evt.target.value})}
                        />
                      </FormGroup>
                      <Checkbox
                        checked={s.useReservationsEmail}
                        onChange={evt => props.onChange({useReservationsEmail: evt.target.checked})}              
                      >
                        Usar otro email para reservas
                      </Checkbox>
                      <FormGroup style={{marginBottom: 20, marginRight: 20, width: 245}}>
                        <ControlLabel style={{minWidth: 70}}>CC</ControlLabel>
                        <FormControl 
                          type="text" 
                          label={getText("En CC")}
                          value={s.reservationsCC}
                          onChange={evt => props.onChange({reservationsCC: evt.target.value})}
                        />
                      </FormGroup>

                    </span>
                  )
                }
              </div>
            </Form>
            {
              s.enableReservationsEmail && (
                <MarkdownField
                  onChange={x => props.onChange({ reservationEmailTemplate: x })}
                  value={s.reservationEmailTemplate}
                  label={getText("Plantilla email")}
                  botLabel = {
                    <ul style = {{fontStyle: "italic", listStyleType: "none"}}>
                      <li style = { {fontWeight: "bold", textDecoration: "underline"}}>{getText("Claves para sustituir en el texto:")}</li>
                      <li>{getText("Nombre de contacto")}: $Contacto</li>
                      <li>{getText("Nombre de proveedor")}: $Proveedor</li>
                      <li>{getText("Actividad")}: $Actividad</li>
                      <li>{getText("Fecha reserva")}: $Fecha</li>
                      <li>{getText("Hora reserva")}: $Hora</li>
                      <li>{getText("Personas")}: $Personas</li>
                      <li>{getText("Niños")}: $Ninos (sin ñ)</li>
                      <li>{getText("Adultos")}: $Adultos</li>
                      <li>{getText("Nombre cliente")}: $Cliente</li>
                    </ul>
                  }
                />
              )
            }
          </Panel.Body>
        </Panel>

        <Panel style={{ maxHeight: 300, overflowY: "scroll"}}>
          <Panel.Heading>Actividades de este proveedor</Panel.Heading>
          <Panel.Body>
            <ul>
              {
                this.props.supplierActivities.map(a => (
                  <li key={a._id}>
                    <Link
                    
                      to={`/private/activity/${encodeURIComponent(a._id)}?`}
                    >
                      {getText(`${a.name}`)}
                      
                    </Link>
                  </li>
                ))
              }
            </ul>
          </Panel.Body>
        </Panel>
      </div>)
  }
}

const mapStateToProps = (state, props) => ({
  supplierActivities : getActivitiesPerSupplier(state, props)[props.supplier._id], 
})

export default connect(mapStateToProps)(SupplierEditor)

